import styled from "styled-components";

export const ServiceTabCompWrapper = styled.div`
  .services_tabImg {
    height: 590px;
    margin-bottom: 40px;
    border-radius: 20px;
    overflow: hidden;
    @media (max-width: 1199px) {
      height: 450px;
      margin-bottom: 25px;
    }
    @media (max-width: 599px) {
      height: 350px;
      margin-bottom: 20px;
    }
    @media (max-width: 479px) {
      height: auto;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .tab_details_wrap {
    h3 {
      font-family: "Inter";
      font-weight: 500;
      font-size: 36px;
      line-height: 1.334;
      color: rgb(22, 22, 22);
      margin-bottom: 15px;
      @media (max-width: 1199px) {
        font-size: 28px;
      }
      @media (max-width: 899px) {
        font-size: 24px;
        margin-bottom: 8px;
      }
      @media (max-width: 599px) {
        font-size: 20px;
      }
    }
    p {
      font-family: "Poppins";
      font-weight: 300;
      font-size: 18px;
      color: rgb(44, 44, 44);
      @media (max-width: 899px) {
        font-size: 16px;
      }
      @media (max-width: 599px) {
        font-size: 14px;
      }
    }
  }
`;

export const DetailsWrapper = styled.div`
  filter: url(#goo);
  display: inline-flex;
  align-items: center;

  button {
    min-width: 191px;
    min-height: 61px;
    background: rgb(255, 24, 24);
    border-radius: 30px;
    font-family: "Poppins";
    font-weight: 800;
    font-size: 15px;
    text-transform: capitalize;
    color: white;
    position: relative;
    z-index: 1;
    transition:
      background 0.3s ease,
      color 0.3s ease;

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      right: 0;
      width: 20px;
      height: 10px;
      background-color: rgba(255, 24, 24, 0.4);
      border-radius: 10px;
      transform: translateY(-50%);
      transition: transform 1s ease;
      z-index: -1;
    }

    &:hover {
      /* background: rgb(255, 235, 235);
      color: black; */

      &::before {
        transform: translateY(-50%) translateX(7px);
      }

      + i {
        transform: translateX(0) scale(1);
        opacity: 1;
        pointer-events: auto;
        /* background: rgb(255, 235, 235);
        color: black; */

        &::before {
          transform: translateY(-50%) translateX(-7px);
        }
      }
    }
  }

  i {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 61px;
    height: 61px;
    border-radius: 50%;
    background: rgb(255, 24, 24);
    color: white;
    margin-left: 10px;
    transform: translateX(-100%) scale(0.8);
    opacity: 0;
    pointer-events: none;
    cursor: pointer;
    position: relative;

    transition:
      transform 0.5s cubic-bezier(0.445, 0.05, 0.55, 0.95),
      opacity 0.4s ease 0.1s,
      background 0.3s ease,
      color 0.3s ease;

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      width: 20px;
      height: 10px;
      background-color: rgba(255, 24, 24, 0.4);
      border-radius: 10px;
      transform: translateY(-50%);
      transition: transform 1s ease;
      z-index: -1;
    }
  }
  .btn_embeded {
    display: none;
  }
`;
